(() => {
  // Debug flag so you can confirm the script loaded
  window.__FREEBIE_GATE_LOADED__ = true;

  function qsAll(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function openModal(modal) {
  if (!modal) return;
  modal.hidden = false;
  modal.classList.add("is-open");
  document.documentElement.classList.add("m-modal-open");
}

function closeModal(modal) {
  if (!modal) return;
  modal.classList.remove("is-open");
  modal.hidden = true;
  document.documentElement.classList.remove("m-modal-open");
}

  function findRelatedModal(triggerBtn) {
    // If the modal is placed right after the button in the same block,
    // this finds the nearest modal in the same container.
    const parent = triggerBtn.closest("div, section, form, .shopify-section, .m-product__info") || document;
    return parent.querySelector("[data-freebie-modal]") || document.querySelector("[data-freebie-modal]");
  }

  // Click handling (delegation)
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-freebie-open]");
    if (openBtn) {
      const modal = findRelatedModal(openBtn);
      // stash url on modal for later
      if (modal) modal.dataset.downloadUrl = openBtn.getAttribute("data-download-url") || "";
      openModal(modal);
      return;
    }

    const closeBtn = e.target.closest("[data-freebie-close]");
    if (closeBtn) {
      const modal = closeBtn.closest("[data-freebie-modal]");
      closeModal(modal);
      return;
    }

    // clicking overlay closes too
    const overlay = e.target.closest(".m-modal__overlay");
    if (overlay && overlay.closest("[data-freebie-modal]")) {
      closeModal(overlay.closest("[data-freebie-modal]"));
    }
  });

  // Submit handling (delegation)
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-freebie-form]");
    if (!form) return;

    e.preventDefault();

    const modal = form.closest("[data-freebie-modal]");
    const errorEl = modal?.querySelector("[data-freebie-error]");
    const stepForm = modal?.querySelector('[data-freebie-step="form"]');
    const stepSuccess = modal?.querySelector('[data-freebie-step="success"]');
    const downloadBtn = modal?.querySelector("[data-freebie-download]");
    const downloadUrl = modal?.dataset.downloadUrl || "";

    if (errorEl) {
      errorEl.style.display = "none";
      errorEl.textContent = "";
    }

    const fdIn = new FormData(form);
    const email = (fdIn.get("email") || "").toString().trim();

    // Basic validation
    if (!email || !email.includes("@")) {
      if (errorEl) {
        errorEl.textContent = "Enter a valid email.";
        errorEl.style.display = "block";
      }
      return;
    }

    try {
      // Add to Shopify contacts via /contact (simple, no apps required)
      const fd = new FormData();
      fd.append("form_type", "customer");
      fd.append("utf8", "✓");
      fd.append("contact[email]", email);
      fd.append("contact[tags]", "freebie,download");

      const res = await fetch("/contact", { method: "POST", body: fd });
      if (!res.ok) throw new Error("Contact submit failed");

      // If no download URL set, show a useful error
      if (!downloadUrl) {
        throw new Error("Missing download URL");
      }

      if (downloadBtn) downloadBtn.href = downloadUrl;
      if (stepForm) stepForm.hidden = true;
      if (stepSuccess) stepSuccess.hidden = false;
    } catch (err) {
      if (errorEl) {
        errorEl.textContent =
          err.message === "Missing download URL"
            ? "Admin: Download URL is missing for this product."
            : "Couldn’t submit. Please try again.";
        errorEl.style.display = "block";
      }
    }
  });

  // Minimog/Shopify section reload hooks (safe no-ops if not used)
  document.addEventListener("shopify:section:load", () => {
    // event delegation already covers this; hook kept for compatibility
  });
})();
